import { SCHEMA_EMPTY_OPERATORS, SCHEMA_OPERATORS } from "@/entities/schema";
import { quotedStringMapper } from "@/utilities/string";

export class FormParser {
  static parseConditions(form) {
    if (!form) {
      return form;
    }
    if (form.fields) {
      form.fields = this.evalConditionalFields(form.fields);
    }
    if (form.groups) {
      for (const group of form.groups) {
        if (group.fields) {
          group.fields = this.evalConditionalFields(group.fields);
        }
      }
    }
    return form;
  }

  static evalConditionalFields(fields) {
    for (const field of fields) {
      if (field.visible && typeof field.visible === "object") {
        field.visible = this.parseConditionalVisible(field.visible);
      }
      if (field.values && typeof field.values === "object") {
        field.values = this.parseConditionalValues(field.values);
      }
    }
    return fields;
  }

  static parseConditionalVisible(data) {
    const str = this.orConditionsToString(data);
    if (str.length) {
      data = new Function("model", "schema", `return ${str}`);
    }
    return data;
  }

  static parseConditionalValues(data = []) {
    const code = ["let result = [];"];

    for (const property in data) {
      const returns = data[property].values;

      const hasListedValues = returns?.length > 0;
      if (!hasListedValues) {
        continue;
      }

      const values = returns.map(quotedStringMapper).join(", ");
      const formulaString = this.orConditionsToString(
        data[property].conditions ? data[property].conditions : data[property]
      );

      if (formulaString) {
        code.push(`if ( ${formulaString} )`);
      }
      code.push(`result = [...result, ...[${values}]];`);
    }

    if (code.length > 1) {
      code.push("return result;");
      return new Function("model", "schema", code.join(" "));
    } else {
      return data;
    }
  }

  static singleConditionToString(data = {}) {
    const modelName = data.model;
    let compareTo = data.value;
    const condition = data.condition;

    if (modelName && SCHEMA_EMPTY_OPERATORS.includes(condition)) {
      return condition === "isNotEmpty"
        ? `!!model["${modelName}"]`
        : `!model["${modelName}"]`;
    }

    if (
      modelName !== undefined &&
      compareTo !== undefined &&
      condition !== undefined &&
      SCHEMA_OPERATORS.includes(condition)
    ) {
      compareTo = this.escapeString(compareTo);
      const isFilled = `model["${modelName}"] !== undefined && model["${modelName}"] !== null && String(model["${modelName}"]).length`;
      const isNumber = `!(isNaN(model["${modelName}"]) || isNaN("${compareTo}"))`;

      if (condition === "contains") {
        return `${isFilled} && String(model["${modelName}"]).includes("${compareTo}")`;
      } else if (condition.includes("<") || condition.includes(">")) {
        return `${isFilled} && ${isNumber} && Number(model["${modelName}"]) ${condition} Number("${compareTo}")`;
      }

      const modelValueAsStringFormula = `String(model["${modelName}"] ?? "")`;
      const compareToAsStringFormula = `"${compareTo ?? ""}"`;
      return `${modelValueAsStringFormula} ${condition} ${compareToAsStringFormula}`;
    }

    return "";
  }

  static orConditionsToString(data) {
    let str = "";
    if (Array.isArray(data)) {
      for (const cond of data) {
        const operator = str.length ? " || " : "";
        str = str.concat(operator).concat(this.singleConditionToString(cond));
      }
    } else {
      str = this.singleConditionToString(data);
    }
    return str;
  }

  static escapeString(condition) {
    if (!condition) {
      return condition;
    }

    return String(condition).replaceAll("\\", "\\\\").replaceAll('"', '\\"');
  }
}
